import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  IconButton,
  Avatar,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const Activity_added = ({ data, supplement, setDeleteConfirm, send, date, standard, section}) => {
  const navigate = useNavigate();
  const handleSupplementDelete = async (data) => {
    setDeleteConfirm(true);
    let body = {
      type: data.type,
      supplement,
    };
    send(body);
  };
  const isDateLessThanCurrent = (dateString) => {
    if (!dateString) return false;

    const passedDate = new Date(dateString);
    const currentDate = new Date();

    return passedDate < currentDate;
  };

  return (
    <>
      {/* <div className="d-flex justify-content-between total_studyMaterial" >
        <div className="d-flex align-items-center gap-2" onClick={() => { navigate('/PublishedQListActvity', { state: { publishedActivity_id: data?.id } }) }}>
          <div>
            <img
              src="/ContentM_images/activity_cm.svg"
              className="cm_icon"
              alt="activity logo"
            ></img>
          </div>
          <span className="steram_preread">{data?.name}</span>
        </div>
        {!isDateLessThanCurrent(date) && <div className="deleteIcon" onClick={() => { handleSupplementDelete(data) }}>
          <img src="/ContentM_images/delete.svg" alt="menu dots logo"></img>
        </div>}
      </div> */}
      <Card
        variant="outlined"
        sx={{
          borderRadius: 2,
          mb: 2,
          boxShadow: 2,
          width: "80%",
          minHeight: 80,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <CardContent sx={{ py: 0.5, px: 2 }}>
          {/* Header */}
          <Typography
            variant="subtitle2"
            fontWeight={600}
            color="primary.main"
            gutterBottom
          >
            Activity
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            {/* Left Side */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              onClick={() =>
                navigate("/PublishedQListActvity", {
                  state: { publishedActivity_id: data?.id, supplement_id: supplement, standard: standard, section: section },
                })
              }
              sx={{ cursor: "pointer" }}
            >
              <img
                src="/ContentM_images/activity_cm.svg"
                className="cm_icon"
                alt="activity logo"
              ></img>
              <Typography variant="body2" fontWeight={500}>
                {data?.name}
              </Typography>
            </Stack>

            {/* Right Side (Delete Button) */}
            {!isDateLessThanCurrent(date) && (
              <IconButton
                onClick={() => handleSupplementDelete(data)}
                color="error"
                size="medium"
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Stack>
        </CardContent>
      </Card>
    </>
  );
};

export default Activity_added;
